import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"
import { apiPath, appPath } from "../config/paths"

export default function Login() {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const { user, isAuthLoading } = useAuth()

    useEffect(() => {
        if (isAuthLoading) return

        if (user) {
            window.location.replace(appPath("/"))
            return
        }

        const token = searchParams.get("token")

        if (!token) {
            navigate("/", { replace: true })
            return
        }

        // POST token in body — never send SSO JWT in query strings (logs, history, Referer).
        fetch(`${apiPath("/auth/login")}?redirect=1`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token }),
            redirect: "follow",
        })
            .then((res) => {
                if (res.redirected) {
                    window.location.replace(res.url)
                    return
                }
                if (res.ok) {
                    window.location.replace(appPath("/"))
                    return
                }
                navigate("/", { replace: true })
            })
            .catch(() => navigate("/", { replace: true }))
    }, [searchParams, navigate, user, isAuthLoading])

    return (
        <div className="trust-wrapper min-h-screen flex items-center justify-center px-4 login-page">
            <p className="text-gray-600">Signing you in…</p>
        </div>
    )
}
